import { ModuleAccordionListFragment } from '@/graphql';
import { FC } from 'react';
import AccordionList from '@/components/modules/AccordionList';
import { parseHtml } from '@/lib/parse-html';

interface AccordionListModuleProps {
  props: CraftModuleFragment<ModuleAccordionListFragment>;
}

const AccordionListModule: FC<AccordionListModuleProps> = ({ props }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  return (
    <AccordionList
      heading={props.heading ?? undefined}
      items={
        props.accordionItems?.map((item) => ({
          id: item?.id ?? '',
          title: item?.itemTitle ?? '',
          content: parseHtml(item?.itemContent),
        })) ?? []
      }
    />
  );
};

export default AccordionListModule;
